module.exports = __webpack_public_path__ + "img/Red.461be144.png";